// @ commons
const { formatText } = require('core/i18n').i18n;

// @constants

const handleErrors = (state, type) => {
    const messageImportErrorMaxValue = formatText('mortgageRequestMortgageEdit-importErrorMaxValue');
    const messageImportErrorMinValue = formatText('mortgageRequestMortgageEdit-importErrorMinValue');
    const messageImportPriceError = formatText('mortgageRequestMortgageEdit-importPriceError');
    const messagePriceErrorMinValue = formatText('mortgageRequestMortgageEdit-priceErrorMinValue');
    const messageAgeErrorMaxValue = formatText('mortgageRequestMortgageEdit-ageErrorMaxValue');
    const messageAgeErrorMinValue = formatText('mortgageRequestMortgageEdit-ageErrorMinValue');

    if (type === 'importeVivienda') {
        if (state.minImportHousing) {
            return messagePriceErrorMinValue;
        }
    } else if (type === 'importeHipoteca') {
        if (state.maxImportMortgage) {
            return messageImportErrorMaxValue;
        } else if (state.minImportMortgage) {
            return messageImportErrorMinValue;
        } else if (state.importPriceMortgage) {
            return messageImportPriceError;
        }
    } else if (type === 'plazo') {
        if (state.maxAge) {
            return messageAgeErrorMaxValue;
        } else if (state.minAge) {
            return messageAgeErrorMinValue;
        }
    }
}


module.exports = {
    handleErrors
}
